import { cn } from "../lib/utils";
import * as React from "react";
import { LoadingBlock } from "./LoadingBlock";
const LABEL_WIDTHS = ["w-32", "w-48", "w-28", "w-40", "w-36"];
/**
 * A skeleton placeholder mirroring the layout of a DataTable /
 * ScrollableDataTable list, built on LoadingBlock, so the swap to real
 * content feels seamless. Use it while loading rows whose shape is known
 * ahead of time; for an indeterminate load with no known layout, use a
 * Spinner instead.
 * @summary Loading placeholder shaped like table rows.
 */
function DataTableLoadingSkeleton({ rows = 5, showSelectionColumn = true, showTrailingCell = false, className, ...props }) {
    return (React.createElement("div", { "aria-hidden": "true", className: cn("flex w-full flex-col", className), ...props },
        React.createElement("div", { className: "flex h-8 items-center border-b border-separator" },
            showSelectionColumn && (React.createElement("div", { className: "flex w-10 shrink-0 items-center px-2" },
                React.createElement(LoadingBlock, { className: "h-4 w-4 rounded-md" }))),
            React.createElement("div", { className: "flex min-w-0 flex-1 items-center px-2" },
                React.createElement(LoadingBlock, { className: "h-3 w-20" })),
            showTrailingCell && (React.createElement("div", { className: "flex w-28 shrink-0 items-center px-2" },
                React.createElement(LoadingBlock, { className: "h-3 w-16" })))),
        Array.from({ length: rows }, (_, i) => (React.createElement("div", { key: i, className: "flex h-12 items-center border-b border-separator" },
            showSelectionColumn && (React.createElement("div", { className: "flex w-10 shrink-0 items-center px-2" },
                React.createElement(LoadingBlock, { className: "h-4 w-4 rounded-md" }))),
            React.createElement("div", { className: "flex min-w-0 flex-1 items-center px-2" },
                React.createElement(LoadingBlock, { className: cn("h-4", LABEL_WIDTHS[i % LABEL_WIDTHS.length]) })),
            showTrailingCell && (React.createElement("div", { className: "flex w-28 shrink-0 items-center px-2" },
                React.createElement(LoadingBlock, { className: "h-5 w-24 rounded-full" }))))))));
}
export { DataTableLoadingSkeleton };
//# sourceMappingURL=DataTableLoadingSkeleton.js.map